import { render, staticRenderFns } from "./actionWarning.vue?vue&type=template&id=46ecd78a&scoped=true"
import script from "./actionWarning.vue?vue&type=script&lang=js"
export * from "./actionWarning.vue?vue&type=script&lang=js"
import style0 from "./actionWarning.vue?vue&type=style&index=0&id=46ecd78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ecd78a",
  null
  
)

export default component.exports